// import Comm from './comm';
let constants = {
    STORAGE_KEY_JWT_TOKEN: 'KEY_TOKEN',
    STORAGE_KEY_USER_INFO:'STORAGE_KEY_USER_INFO',

};

export default constants;